module.exports = __webpack_public_path__ + "img/right-3.88e24543.png";